import { SurvicateService } from './../../../services/survicate.service';
import { Component, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { IBlankslate, ITag, IToast, LayoutService, Status, ToastService, IAlert } from 'codex-lib';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Envelope } from '../../model/envelope';
import { SignatoryEdit } from '../../model/signatory-edit';
import { CheckboxState } from 'src/app/enum/checkbox-state';
import * as R from 'ramda';
import { Subject } from 'rxjs';
import { debounceTime, take } from 'rxjs/operators';
import { CPFCNPJUtil } from 'src/app/util/CPF-CNPJ-util';
import { LanguageUtil } from 'src/app/util/language-util';
import { SignatureStatus } from 'src/app/enum/signature-status';
import { TranslateService } from '@ngx-translate/core';
import { TableSignUserBase } from '../../model/table-sign-user-base';
import { EnvelopeEditService } from '../../services/envelope-edit.service';
import { SignatoryTypeForm } from 'src/app/enum/signatory-type-form';
import { EnvelopeEditTabs } from 'src/app/enum/envelope-edit-tabs';
import { AuthService } from 'src/app/services/auth.service';
import { DocumentRejectedService } from 'src/app/services/document-rejected.service';
import { ModalIntentType } from 'src/app/enum/modal-intent-type.enum';
import { ParticipantTypeEnum } from 'src/app/enum/participant.enum';
import { SharedService } from 'src/app/services/shared-service.service';
import { SignatureType } from 'src/app/enum/signature-type';
import { EnvelopeSignatoryService } from 'src/app/modules/signature/services/envelope-signatory.service';

@Component({
  selector: 'app-edit-envelope-signatories',
  templateUrl: './envelope-edit-signatories.component.html',
  styleUrls: ['./envelope-edit-signatories.component.scss']
})

export class EnvelopeEditSignatoriesComponent implements OnDestroy {

  @ViewChild('serchMenu') serchMenu;
  @ViewChild('modalReuseSignatures') modalReuseSignatures;

  envelope: Envelope;
  signatories: Array<SignatoryEdit> = [];
  acceptWhatsapp: boolean;
  elementSelected: SignatoryEdit;
  filteredElements: Array<SignatoryEdit> = [];
  selectedElements: Array<string> = [];
  tableHeaderCheckboxState: CheckboxState;
  hideblankSlate: boolean;
  searchSubject: Subject<string> = new Subject();
  accessAuthentication: boolean;
  envelopeLanguage = 1;
  SignatureStatus = SignatureStatus;
  searchText = '';
  checkboxAllElements: boolean;
  tableSignUserBase: TableSignUserBase;
  typeForm: number = SignatoryTypeForm.Insert;
  activeModal: NgbActiveModal;
  reuseSignaturesModalRef: NgbActiveModal;
  isOrdered: boolean;
  canSendWhatsApp: boolean;
  signatoriesRemoveds: any[] = [];
  isMoreThanOneRejected: boolean;
  modalIntentType = ModalIntentType;
  participantType = ParticipantTypeEnum;
  inactiveTag = {
      description: 'inactive',
      tooltip: 'envelope.signatory.tooltip.signatoryTypeRoleInactive',
      tooltipPlacement: 'top'
    };;

  tagWaiting: ITag = {
    description: 'envelope-edit.awaiting',
    type: Status.WARNING
  };

  tagSigned: ITag = {
    description: 'envelope-edit.signed',
    type: Status.INFO
  };

  tagRejected: ITag = {
    description: 'modalReasonRejected.tag.rejected',
    type: Status.DANGER
  };

  alertOptions: IAlert = {
    type: 'warning',
    dismissible: false
  };

  blankSlate: IBlankslate;
  blankSlateSearch: IBlankslate;
  isSignFreemium: boolean = false;

  constructor(
    public layoutService: LayoutService,
    private route: ActivatedRoute,
    private envelopeEditService: EnvelopeEditService,
    private translateService: TranslateService,
    private modalService: NgbModal,
    private toastService: ToastService,
    private survicateService: SurvicateService,
    private authService: AuthService,
    private documentRejectedService: DocumentRejectedService,
    private sharedService: SharedService,
    private envelopeSignatoryService: EnvelopeSignatoryService) {
    this.tableSignUserBase = new TableSignUserBase(translateService);
    this.tableSignUserBase.createInitObject().pipe(take(1)).subscribe(x => x.subscribe(() => this.onInit()));
    this.accessAuthentication = this.envelopeEditService.isAccessAuthentication;
    if (!this.authService.signUserModel) {
      return;
    }
    this.canSendWhatsApp = this.authService.signUserModel.sendWhatsapp;
  }

  ngOnDestroy(): void {
    this.sharedService.updateIsEditEnvelope(false);
    this.layoutService.toggleViewer(false);
  }

  onInit() {
    this.sharedService.updateIsEditEnvelope(true);
    this.isSignFreemium = this.survicateService.isSignFree();
    const signatories = this.envelopeEditService.getModelData(EnvelopeEditTabs.Signatory);
    this.signatories = signatories?.signatories === undefined ? [] : signatories?.signatories;

    if (this.signatories.length === 0) {
      this.setValues();
    } else {
      this.filteredElements = this.signatories;
      this.signatoriesRemoveds = signatories.signatoriesRemoveds;
      this.documentRejectedService.verifyIsRemoveDocumentRejected(this.signatories);
    }

    this.isOrdered = this.envelopeEditService.isOrdered;

    this.blankSlate = {
      icon: {
        prefix: 'fad',
        iconName: 'user-plus'
      },
      buttonText: 'add'
    };

    this.blankSlateSearch = {
      icon: {
        prefix: 'fad',
        iconName: 'search-minus'
      },
      buttonText: 'cleanSearch'
    };

    this.searchSubject
      .pipe(debounceTime(200))
      .subscribe((value) => {
        if (value) {
          this.filteredElements = this.signatories.filter(item =>
            Object.keys(item).some(
              k =>
                item[k] != null &&
                item[k]
                  .toString()
                  .toLowerCase()
                  .includes(value.toLowerCase())
            )
          );
        } else {
          this.filteredElements = this.signatories;
        }
      });
  }

  setValues() {
    this.route.params.subscribe((params: Params) => {
      this.envelopeEditService
        .getEnvelope(params['envelopeId'])
        .subscribe(envelope => {
          this.envelope = envelope;
          this.envelopeLanguage = this.envelope.language;

          this.envelope.signatories.forEach(x => {
            const signatory = new SignatoryEdit();
            signatory.id = x.id;
            signatory.order = x.order;
            signatory.name = x.name;
            signatory.mail = x.mail;
            signatory.ssn = x.ssn;
            signatory.phoneNumber = x.phoneNumber;
            signatory.acceptWhatsApp = x.acceptWhatsApp;
            signatory.sendWhatsApp = x.sendWhatsApp;
            signatory.ssnWithMask = CPFCNPJUtil.formatSsn(x.ssn);
            signatory.signatureTypeValue = this.onSignatureType(x.signatureType);
            signatory.subscriberTypeValue = this.onSubscriberType(x.subscriberType);
            signatory.status = x.status;
            signatory.signatureTypeSelectedValue = x.signatureTypeSelected ? this.onSignatureType(x.signatureTypeSelected) : '';
            signatory.checked = false;
            signatory.signatureType = x.signatureType;
            signatory.subscriberType = x.subscriberType;
            signatory.envelopeSignatoryId = x.envelopeSignatoryId;
            signatory.signatoryTypeRoleId = x.signatoryTypeRoleId;
            signatory.signatoryTypeRole = x.signatoryTypeRole;
            this.signatories.push(signatory);
          });
          this.filteredElements = this.signatories;
          this.documentRejectedService.verifyIsRemoveDocumentRejected(this.signatories);

          const infoTabSignatories = {
            signatories: this.filteredElements,
            signatoriesRemoveds: this.signatoriesRemoveds
          };

          this.envelopeEditService.setModelData(infoTabSignatories, EnvelopeEditTabs.Signatory);
        });
    });
  }

  canShowAlert(){
    const envelope = this.envelopeEditService.Envelope || this.envelope;
    return (envelope?.responsibles?.length ?? 0) > 0;
  }

  canShowGrid() {
    return R.pathOr(0, ['length'], this.filteredElements) >= 1;
  }
  canObfuscateCpfCnpj(cpfCnpj?: string): string {
    return CPFCNPJUtil.canObfuscateCpfCnpj(cpfCnpj);
  }
  onSubscriberType(id: number | { id: number, value: string }) {
    const extractedId = typeof id === 'object' ? id.id : id;
    return this.tableSignUserBase.subscriberType.GetValue(extractedId);
  }

  onSignatureType(id: number | { id: number, value: string }) {
    const extractedId = typeof id === 'object' ? id.id : id;
    return this.tableSignUserBase.signatureType.GetValue(extractedId);
  }

  onBlankSlateButtonClick() {
    this.hideblankSlate = true;
    this.serchMenu.clear();
  }

  onSearch(value: string) {
    this.filteredElements = [];
    this.searchText = value;
    this.searchSubject.next(value);
  }

  checkLanguagePtEnvelope() {
    return LanguageUtil.isCurrentLanguagePT(this.envelopeLanguage) && LanguageUtil.isCurrentLanguagePT(this.translateService.currentLang);
  }

  onCheckbox(event, element) {
    if (event) {
      element.id ? this.selectedElements.push(element.id.toString()) : this.selectedElements.push(element.idAdd.toString().concat('a'));
    } else {
      element.id ?
        this.selectedElements = this.selectedElements.filter(x => x !== element.id.toString()) :
        this.selectedElements = this.selectedElements.filter(x => x !== element.idAdd.toString().concat('a'));
    }

    const index = element.id ?
      this.filteredElements.indexOf(this.filteredElements
        .find(this.findIdToUpdate, element.id)) :
      this.filteredElements.indexOf(this.filteredElements
        .find(this.findIdAddToUpdate, element.idAdd));

    this.filteredElements[index].checked = event;
    this.elementSelected = this.selectedElements.length === 1 ? this.filteredElements.find(x => x.checked === true) : undefined;
  }

  onCheckboxAll(event) {
    this.checkboxAllElements = event;
    this.filteredElements.forEach((el: any) => {
      this.onCheckbox(event, el);
    });
  }

  canBeSingular() {
    return R.pathOr(0, ['length'], this.selectedElements) == 1;
  }

  canShowButtonRemove() {
    return R.pathOr(0, ['length'], this.selectedElements) >= 1 && this.canStatusSelectionToRemove();
  }

  canStatusSelectionToRemove() {
    const checkedElements = this.filteredElements.filter(x => x.checked === true);
    return checkedElements.every(
      e => e.status === SignatureStatus.Awaiting || e.status === SignatureStatus.Declined
    );
  }

  showConfirmationDelete(confirmModalContent) {
    this.activeModal = this.modalService.open(confirmModalContent);
  }

  findIdToUpdate(value) {
    return value.id === this;
  }

  findIdAddToUpdate(value) {
    return value.idAdd === this;
  }

  confirmModalClose() {
    this.activeModal.dismiss();
  }

  canShowButtonEdit() {
    if (this.elementSelected && this.elementSelected.hasOwnProperty('status')) {
      return this.canBeSingular() &&
        (this.elementSelected.status === SignatureStatus.Awaiting ||
          this.elementSelected.status === SignatureStatus.Declined);
    }
    return false;
  }

  showEditSignatory(modalContent: any) {
    const selected = this.elementSelected;

    const openModal = () => {
      this.activeModal = this.modalService.open(modalContent, { size: 'lg', scrollable: false });
    };

    if (selected && selected.envelopeSignatoryId && !selected.saveJustInEnvelope) {
      this.envelopeSignatoryService
        .getResumeDetails(selected.envelopeSignatoryId, false)
        .pipe(take(1))
        .subscribe({
          next: (data) => {
            this.elementSelected = {
              ...selected,
              ...data.value
            };
            openModal();
          },
          error: (_) => {
            this.elementSelected = selected;
            openModal();
          }
        });
    } else {
      this.elementSelected = selected;
      openModal();
    }
  }

  insertOrUpdateSignatoryEdit(signatoryEditForm: any) {
    const formData = signatoryEditForm;
    const formId = formData.id;
    const formTempId = formData.tempId ? formData.tempId : null;

    const sigTypeList = this.tableSignUserBase.signatureType.List();
    const subTypeList = this.tableSignUserBase.subscriberType.List();
    const normalize = (idOrObj: any, list: any[]) => {
      const id = typeof idOrObj === 'object' ? idOrObj.id : idOrObj;
      return list.find(item => item.id === id);
    };
    const sigType = normalize(formData.signatureType, sigTypeList);
    const subType = normalize(formData.subscriberType, subTypeList);

    let index = this.signatories.findIndex(s => s.id === formId);

    if (index < 0 && formTempId) {
      index = this.signatories.findIndex(s => s.id === formTempId);
    }

    if (index >= 0) {
      const s = this.signatories[index];
      s.id = formData.id;
      s.name = formData.name;
      s.mail = formData.mail;
      s.signatureType = sigType?.id;
      s.signatureTypeValue = sigType?.value;
      s.subscriberType = subType?.id;
      s.subscriberTypeValue = subType?.value;
      s.phoneNumber = formData.phoneNumber;
      s.acceptWhatsApp = formData.acceptWhatsApp;
      s.sendWhatsApp = formData.acceptWhatsApp;
      s.idAdd = formData.tempId;
      s.saveTo = s.id? true : formData.saveTo;
      s.saveJustInEnvelope = formData.saveJustInEnvelope;
      s.allSegments  = formData.allSegments;
      s.segments = formData.segments;
      s.signatoryTypeRoleId = formData.signatoryTypeRoleId;
      s.isEdited = formData.isEdited ?? true;
      s.signatoryTypeRole = formData.signatoryTypeRole;
      this.elementSelected = s;
    } else {
      const signatory = new SignatoryEdit();
      signatory.id = formData.id;
      signatory.idAdd = formData.tempId;
      signatory.order = this.envelopeEditService.isOrdered ? this.nextSignatoryOrder() : 0;
      signatory.name = formData.name;
      signatory.mail = formData.mail;
      signatory.ssn = formData.ssn;
      signatory.ssnWithMask = CPFCNPJUtil.formatSsn(formData.ssn);
      signatory.phoneNumber = formData.phoneNumber;
      signatory.acceptWhatsApp = formData.acceptWhatsApp;
      signatory.sendWhatsApp = formData.sendWhatsApp;
      signatory.signatureType = sigType?.id;
      signatory.signatureTypeValue = sigType?.value;
      signatory.subscriberType = subType?.id;
      signatory.subscriberTypeValue = subType?.value;
      signatory.status = formData.status || SignatureStatus.Awaiting;
      signatory.checked = false;
      signatory.saveTo = formData.saveTo;
      signatory.saveJustInEnvelope = formData.saveJustInEnvelope;
      signatory.allSegments  = formData.allSegments;
      signatory.segments = formData.segments;
      signatory.signatoryTypeRoleId = formData.signatoryTypeRoleId;
      signatory.signatoryTypeRole = formData.signatoryTypeRole;
      this.signatories.push(signatory);
    }

    const infoTabSignatories = {
      signatories: this.signatories,
      signatoriesRemoveds: this.signatoriesRemoveds
    };
    this.envelopeEditService.setModelData(infoTabSignatories, EnvelopeEditTabs.Signatory);
    this.filteredElements = this.signatories;
  }

  showAddSignatoriesBookModal(modalContent) {
    this.activeModal = this.modalService.open(modalContent, { size: 'xl', scrollable: false, backdropClass: 'override-backdrop' });
  }

  submitSignatoriesBookModalClick(selectedSignatoriesBook) {
    if (!Array.isArray(selectedSignatoriesBook.data))
      selectedSignatoriesBook.data = [selectedSignatoriesBook.data];

    const hasInvalidSignatureType = selectedSignatoriesBook.data.some(s =>
        s.signatureType?.id === SignatureType.DIGITAL ||
        s.signatureType?.id === SignatureType.BOTH
      );
    if (this.envelopeEditService.includeRubric && hasInvalidSignatureType) {
      const toast: IToast = {
        text: this.translateService.instant('envelopeEdit.toastErrorAddSignatory'),
        autoHide: true,
        type: 'danger'
      };
      this.toastService.createNewToast(toast);
      return;
    }

    const removedItems = this.signatoriesRemoveds.filter((item) =>
      this.signatoriesRemoveds.some(
        (removed) => removed.id === item.id || removed.name === item.name
      )
    );

    if (removedItems.length > 0) {
      this.isMoreThanOneRejected = removedItems.length > 1;
      this.signatoriesRemoveds = selectedSignatoriesBook.data;
      this.reuseSignaturesModalRef = this.modalService.open(this.modalReuseSignatures, {
        size: 'xs',
      });
    } else {
      this.mergeList(selectedSignatoriesBook.data);
      this.activeModal.close();
    }
  }

  confirmModalReuseSignatures(event: boolean) {
    this.signatoriesRemoveds.forEach((item) => {
      const refused = this.signatoriesRemoveds.some(
        (removed) => removed.id === item.id || removed.name === item.name
      );
      if (refused) {
        item.reuseSignatures = event;
      }
    });
    this.mergeList(this.signatoriesRemoveds);
    this.closeModalReuseSignatures();
  }

  closeModalReuseSignatures() {
    this.reuseSignaturesModalRef.close();
    this.activeModal.close();
  }

  mergeList(signatories: Array<any>) {
    let counter = 0;
    let addSignatory = false;
    signatories.forEach(el => {
      const originalToRemove = this.signatories.findIndex(item => item.id === el.tempId);
      if (originalToRemove !== -1) this.signatories.splice(originalToRemove, 1);

      const acceptWhatsApp = el.acceptWhatsApp ?? el.notifyByWhatsApp ?? el.notifyByWhatsapp;

      const signatory = new SignatoryEdit();
      signatory.id = el.tempId ?? el.id;
      signatory.order = this.envelopeEditService.isOrdered ? this.nextSignatoryOrder() : 1;
      signatory.name = el.name;
      signatory.mail = el.mail;
      signatory.ssnWithMask = el.ssn;
      signatory.ssn = el.ssn;
      signatory.phoneNumber = el.phoneNumber;
      signatory.acceptWhatsApp = acceptWhatsApp;
      signatory.sendWhatsApp = el.sendWhatsApp ?? false;
      signatory.signatureTypeValue = this.onSignatureType(el.signatureType);
      signatory.subscriberTypeValue = this.onSubscriberType(el.subscriberType);
      signatory.signatureType = el.signatureType.id;
      signatory.subscriberType = el.subscriberType.id;
      signatory.status = 1;
      signatory.checked = false;
      signatory.reuseSignatures = el.reuseSignatures;
      signatory.saveTo = el.saveTo ?? true;
      signatory.segments = el.segments;
      signatory.allSegments = el.allSegments;
      signatory.saveJustInEnvelope = el.saveJustInEnvelope;
      signatory.signatoryTypeRoleId = el.signatoryTypeRoleId;
      signatory.signatoryTypeRole = el.signatoryTypeRole;
      addSignatory = this.mergeById(signatory);
      if (addSignatory) {
        counter++;
      }
    });

    if (counter > 0) {
      const toastAdded: IToast = {
        text: this.translateService.instant('envelope.signatory.toast.addedNotification', { count: counter }),
        autoHide: true
      };
      this.toastService.createNewToast(toastAdded);
    }
  }

  mergeById(signatory: any) {
    const index = this.signatories.findIndex((e) => e.id === signatory.id);
    if (index === -1) {
      this.signatories.push(signatory);

      const infoTabSignatories = {
        signatories: this.signatories,
        signatoriesRemoveds: this.signatoriesRemoveds
      };

      this.envelopeEditService.setModelData(infoTabSignatories, EnvelopeEditTabs.Signatory);
      this.filteredElements = this.signatories;
      return true;
    }
    return false;
  }

  nextSignatoryOrder(): number {
    const order = Math.max(...this.signatories.map(el => el.order), 0);
    return order + 1;
  }

  confirmModalYesClick() {
    for (let index = 0; index < this.signatories.length;) {
      if (this.signatories[index].checked) {
        if (this.signatories[index].status === SignatureStatus.Declined)
          this.signatoriesRemoveds.push(this.signatories[index]);

        const orderRemoved = this.signatories[index].order;
        this.signatories.splice(index, 1);

        const infoTabSignatories = {
          signatories: this.signatories,
          signatoriesRemoveds: this.signatoriesRemoveds
        };

        this.envelopeEditService.setModelData(infoTabSignatories, EnvelopeEditTabs.Signatory);
        this.filteredElements = this.signatories;
        let indexUpdate = index;

        if (this.envelopeEditService.isOrdered) {
          const notReorder = this.signatories.some(x => x.order === orderRemoved);
          while (indexUpdate < this.signatories.length && !notReorder) {
            this.signatories[indexUpdate].order = this.signatories[indexUpdate].order != 1 ?
              this.signatories[indexUpdate].order - 1 : this.signatories[indexUpdate].order;
            indexUpdate++;
          }
        }
      } else {
        index++;
      }
    }
    if (this.filteredElements.length == 0) {
      const toast: IToast = {
        text: this.translateService.instant('envelope-edit.toast.completeNotification'),
        autoHide: true,
        type: 'danger'
      };
      this.toastService.createNewToast(toast);
    }
    this.elementSelected = undefined;
    this.selectedElements = [];
    this.activeModal.close();
  }

  showSignatoriesOrderModal(modalContent) {
    this.activeModal = this.modalService.open(modalContent, { scrollable: true });
  }

  submitSignatoriesOrderModalClick(signatories) {
    this.activeModal.close();
    if (this.envelopeEditService.isOrdered) {
      this.mergeSignatoriesOrder(signatories);
    }
  }

  mergeSignatoriesOrder(signatories: Array<any>) {
    let editOrder = false;
    let counter = 0;

    signatories.forEach(el => {
      if (!el.disabled) {
        const index = this.signatories.findIndex((e) => e.id === el.id);
        if (index !== -1) {
          editOrder = this.editSignatoriesOrder(index, el.order);
          this.signatories[index].order = editOrder ? el.order : this.signatories[index].order;
          if (editOrder) {
            counter++;
          }
        }
      }
    });

    if (counter > 0) {
      this.signatories.sort((a, b) => a.order - b.order);

      const infoTabSignatories = {
        signatories: this.signatories,
        signatoriesRemoveds: this.signatoriesRemoveds
      };

      this.envelopeEditService.setModelData(infoTabSignatories, EnvelopeEditTabs.Signatory);
      this.filteredElements = this.signatories;

      const toast: IToast = {
        text: this.translateService.instant('envelope-edit.toast.orderedNotification')
        , autoHide: true, type: 'success'
      };
      this.toastService.createNewToast(toast);
    }
  }

  editSignatoriesOrder(index, order) {
    return this.signatories[index].order == order ? false : true;
  }

  changeAccessAuthentication(event) {
    this.envelopeEditService.isAccessAuthentication = event;
    this.accessAuthentication = event;
  }

  needSendWhatsapp(value: boolean, signatoryId: any, signatoryIdAdd: any) {
    const signatory = signatoryId != null
      ? this.signatories.find(x => x.id === signatoryId)
      : this.signatories.find(x => x.idAdd === signatoryIdAdd);

    if (!signatory) {
      return;
    }

    signatory.sendWhatsApp = value;
    signatory.isEdited = true;

    const infoTabSignatories = {
      signatories: this.signatories,
      signatoriesRemoveds: this.signatoriesRemoveds
    };

    this.envelopeEditService.setModelData(infoTabSignatories, EnvelopeEditTabs.Signatory);
  }

  canToggleWhatsApp(element: SignatoryEdit): boolean {
    return !!element.phoneNumber &&
      this.getSignatureTypeId(element.signatureType) !== SignatureType.INPERSON &&
      element.status !== SignatureStatus.Signed;
  }

  private getSignatureTypeId(signatureType: any): number {
    return typeof signatureType === 'object' ? signatureType?.id : signatureType;
  }

  toastWhatsFree() {
    const toast: IToast = {
      text: this.translateService.instant('contacts.acceptWhatsappSignFreeToast'),
      autoHide: true,
    };
    this.toastService.createNewToast(toast);
  }
}
